
function Testing() {
    console.log('Desmond');


    console.log('hi');
}

export default Testing